// src/components/TopNav.js

import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, LogOut, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";



export default function TopNav() {
  const { user, logout } = useAuth();
 
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate("/");
  };
  
  const location = useLocation();

  // hide on login/signup
  if (location.pathname === "/" || location.pathname === "/signup") return null;

  const initials =
    user?.role === "admin"
      ? "AD"
      : (user?.name || "User")
          .split(" ")
          .map(n => n[0])
          .join("")
          .slice(0, 2)
          .toUpperCase();

  return (
    <div
      style={{ backgroundColor: "#4b5563", backgroundColor: "rgba(75, 85, 99, 0.8)", backdropFilter: "blur(12px)", }}
      className="fixed top-0 left-0 w-full text-white flex justify-around backdrop-blur-md  p-3 text-sm no-print"
	  
    >
      {/* LEFT: Home */}
      <Link to="/home" className="hover:opacity-80">
        <Home className="w-4 h-4 mt-4 text-white-500 " />
        
      </Link>

      {/* RIGHT: Initials (link to profile) */}
	  <div
          style={{ borderColor: "#9ca3af", borderWidth: "2px" }}
          className="w-12 h-12 flex items-center justify-center rounded-full shadow-md"
        >
      <Link
        to="/profile"
        className="text-xs font-semibold text-white hover:bg-white/10"
        aria-label="Profile"
      >
        {initials}
      </Link>
	  </div>
	  
	 <button
       onClick={handleLogout}
       className="hover:bg-gray-100"
       >
       <LogOut className="w-4 h-4 mr-2 text-white-500" />
       
       </button>
    </div>
  );
}
